import { REDUX_ROUTER_NAMESPACE, REDUX_ROUTING_PAGE_NAMESPACE } from "Common/routingUtils";
import { connect } from "react-redux";
import actionCreators from "./redux/actionCreators";
import { getBackUrlHash } from "./redux/selectors";
import Switcher from "./switcher";
import { getActiveDocumentType } from "../Documents";
const mapStateToProps = (state) => {
    var _a, _b;
    return ({
        routingPageKey: state[REDUX_ROUTING_PAGE_NAMESPACE].key,
        locationHash: (_b = (_a = state[REDUX_ROUTER_NAMESPACE]) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.hash,
        backUrlHash: getBackUrlHash(state),
        documentType: getActiveDocumentType(state)
    });
};
const mapDispatchToProps = (dispatch) => ({
    onSidebarComponentChanged: (backUrlHash) => dispatch(actionCreators.setBackUrlHash(backUrlHash))
});
export default connect(mapStateToProps, mapDispatchToProps)(Switcher);
